import { useTranslation } from "@/translations";

import { IconButton } from "../../Button/IconButton";
import { XIcon } from "../../Icons/XIcon";

export function CommentFieldInlineCancel({
  size,
  onCancel,
  isCancellable,
}: {
  size?: React.ComponentProps<typeof IconButton>["size"];
  onCancel?: () => void;
  isCancellable?: boolean;
}): React.ReactNode {
  const { t } = useTranslation();
  if (!isCancellable || !onCancel) {
    return null;
  }

  return (
    <IconButton onClick={onCancel} size={size} icon={<XIcon />} styling="secondary" title={t("common.action.cancel")} />
  );
}
